import React from "react";
import { Col, Container, Row, Card } from "react-bootstrap";
import Input from "./Input";
import "../stylesheets/Create.scss";
import Navbar from "./Navbar";
import { Link } from "react-router-dom";
import ForwardArrow from "../Assets/forward-arrow.svg";
import Exclamation from "../Assets/exclamationcircle.svg";
import PrimaryButton from "../util/Btns/PrimaryButton";
import AgreementText from "./agreement-text";
import Checkbox from "../util/Btns/CheckboxBtnv1";
import MailSent from "../Assets/mail-sent.svg";
import { CustomToast } from "../util/custom-toast/CustomToast";
import downloadIcon from "../Assets/download2.svg";
import ConsoleLocalStorage from "../storage/storage";
import { hideLoader, showLoader } from "../util/loader/CustomLoader";
import FilePicker from "../util/file-picker/file-picker";
import DevConsoleAPI from "../api/DevConsole";
import { orgStatus } from "../util/helpers/statusHelper";
import TextArea from "./forms/text-area";
import { downloadAuthenticatedDocument } from "../util/authenticatedMedia";

/** Strip http(s) scheme so WAF CRS 931130 does not match ARGS:website */
function toWafSafeWebsite(value) {
  if (value == null || typeof value !== "string") return "";
  return value.trim().replace(/^(?:https?):\/\//i, "");
}

class CreateOrganization extends React.Component {
  constructor(props) {
    super(props);

    this.user = ConsoleLocalStorage.getUser();

    if (this.user === undefined || this.user === null)
      window.location = "/login";

    this.state = {
      step: 0,
      type: 0,
      show: true,
      name: { value: "", warning: { msg: "", class: "" } },
      publisherName: { value: "", warning: { msg: "", class: "" } },
      website: { value: "", warning: { msg: "", class: "" } },
      address1: { value: "", warning: { msg: "", class: "" } },
      address2: { value: "", warning: { msg: "", class: "" } },
      city: { value: "", warning: { msg: "", class: "" } },
      state: "Maharashtra",
      country: "IN",
      kycAgreement: { fileName: "", url: "" },
      authLetter: { fileName: "", url: "" },
      iAgree: false,
      orgRejected: false,
      rejectionText: "",
    };

    //if(this.user.organization !== undefined)

    // let api = new DevAuthAPI();
    // api.getDeveloper(this.user.id);
  }
  componentDidMount() {
    this.fetchOrganization();
    if (
      ConsoleLocalStorage.getOrganization()?.status ===
      orgStatus.approved.status
    )
      this.props.history.push("/console");
    if (
      ConsoleLocalStorage.getOrganization()?.status ===
      orgStatus.rejected.status
    ) {
      this.setState({
        orgRejected: true,
        rejectionText: ConsoleLocalStorage.getOrganization()?.comment,
      });
      this.setState({ step: 2 });
    }
  }

  submitStepTwoForm() {
    if (!this.state.iAgree)
      return CustomToast("Agree to terms & conditions first");
    if (this.state.kycAgreement.fileName.length === 0)
      return CustomToast("Please upload ID Proof");

    if (this.state.type === 1 && this.state.authLetter.fileName.length === 0)
      return CustomToast("Please upload Authorization Letter");
    // this.setState({step:2})

    let docs = [];
    docs.push({
      name: "id-proof",
      url: this.state.kycAgreement.url,
      type: "pan",
    });

    if (this.state.type === 1) {
      docs.push({
        name: "authorization-letter",
        url: this.state.authLetter.url,
        type: "pan",
      });
    }

    let api = new DevConsoleAPI();
    showLoader();

    api
      .uploadKYC({ adminId: this.user.id, doc: docs })
      .then((response) => {
        hideLoader();
        // localStorage.clear();
        this.setState({ step: 2, orgRejected: false });
        this.fetchOrganization();
      })
      .catch((error) => {
        hideLoader();
        CustomToast(
          error?.response?.data?.message ||
            error?.message ||
            "Unable to upload documents. Please try again."
        );
      });
  }

  fetchOrganization() {
    showLoader();
    // let organization = ConsoleLocalStorage.getOrganization();
    let api = new DevConsoleAPI();
    if (this.user.organization === null) {
      hideLoader();
      return;
    }
    api
      .getOrganizationWithToken()
      .then((response) => {
        hideLoader();
        let data = response.data.data;
        // ConsoleLocalStorage.setOrganization(data);
        // if (data && Object.keys(data).length === 0) {
        //   setTimeout(() => this.props.history.replace("/organization"), 10);
        // }
        // else
        if (data.status === orgStatus.draft.status) {
          this.setState({ step: 1 });
        } else if (data.status === orgStatus.pending.status) {
          this.setState({ step: 2, orgRejected: false });
        } else if (data.status === orgStatus.rejected.status) {
          this.setState({ orgRejected: true, rejectionText: data.comment });
          this.setState({ step: 2 });
        } else if (data.status === orgStatus.approved.status) {
          this.props.history.replace("/console");
        }

        let tempState = { ...this.state };
        tempState.name.value = data.name;
        tempState.publisherName.value = data.publisherName;
        tempState.website.value = data.website;
        tempState.address1.value = data.address.address1;
        tempState.address2.value = data.address.address2;
        tempState.city.value = data.address.city;
        tempState.country = data.address.country;
        tempState.state = data.address.state;
        tempState.type = data.type === "organization" ? 1 : 0;

        this.setState({ ...tempState });
      })
      .catch((error) => {
        hideLoader();
        //console.log(error);
      });
  }

  updateData() {
    this.setState({ step: 0 });
  }

  validateUrl(value) {
    return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(
      value
    );
  }

  validateStepOneForm() {
    let validate = true;
    if (
      !this.state.name.value ||
      this.state.name.value.length < 3 ||
      !this.validateNameFormat(this.state.name.value)
    ) {
      let tempState = { ...this.state.name };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Required";
      this.setState({ name: tempState });
      validate = false;
    }

    if (
      !this.state.publisherName.value ||
      this.state.publisherName.value.length < 3 ||
      !this.validateNameFormat(this.state.publisherName.value)
    ) {
      let tempState = { ...this.state.publisherName };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Required";
      this.setState({ publisherName: tempState });
      validate = false;
    }

    if (
      this.state.type === 1 &&
      (!this.state.website.value ||
        this.state.website.value.length < 4 ||
        !this.validateUrl(this.state.website.value))
    ) {
      let tempState = { ...this.state.website };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Required";
      this.setState({ website: tempState });
      validate = false;
    }

    if (
      this.state.type === 0 &&
      this.state.website.value?.length > 0 &&
      (this.state.website.value?.length < 4 ||
        !this.validateUrl(this.state.website.value))
    ) {
      let tempState = { ...this.state.website };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Required";
      this.setState({ website: tempState });
      validate = false;
    }

    if (
      !this.state.address1.value ||
      this.state.address1.value.length < 3 ||
      !this.validateAddressFormat(this.state.address1.value)
    ) {
      let tempState = { ...this.state.address1 };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Required";
      this.setState({ address1: tempState });
      validate = false;
    }

    if (
      !this.state.address2.value ||
      this.state.address2.value.length < 3 ||
      !this.validateAddressFormat(this.state.address2.value)
    ) {
      let tempState = { ...this.state.address2 };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Required";
      this.setState({ address2: tempState });
      validate = false;
    }

    if (
      !this.state.city.value ||
      this.state.city.value.length < 3 ||
      !this.validateCityFormat(this.state.city.value)
    ) {
      let tempState = { ...this.state.city };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Required";
      this.setState({ city: tempState });
      validate = false;
    }

    if (!validate) return;
    if (
      ConsoleLocalStorage.getOrganization()?.id
        ? this.updateOrganization()
        : this.createOrganization()
    );
    //this.setState({step:1});
  }

  createOrganization() {
    showLoader();
    let api = new DevConsoleAPI();
    api
      .createOrganization({
        adminId: this.user.id,
        name: this.state.name.value,
        type: this.state.type === 0 ? "individual" : "organization",
        publisherName: this.state.publisherName.value,
        // Strip https:// so WAF CRS 931130 does not block ARGS:website
        website: toWafSafeWebsite(this.state.website.value),
        address1: this.state.address1.value,
        address2: this.state.address2.value,
        city: this.state.city.value,
        state: this.state.state,
        country: this.state.country,
      })
      .then((response) => this.onSuccess(response))
      .catch((error) => this.onError(error));
  }

  updateOrganization() {
    showLoader();
    let api = new DevConsoleAPI();
    api
      .updateOrganization({
        address: {
          address1: this.state.address1.value,
          address2: this.state.address2.value,
          city: this.state.city.value,
          state: this.state.state,
          country: this.state.country,
        },
        adminId: this.user.id,
        name: this.state.name.value,
        type: this.state.type === 0 ? "individual" : "organization",
        publisherName: this.state.publisherName.value,
        website: toWafSafeWebsite(this.state.website.value),
      })
      .then((response) => this.onSuccess(response))
      .catch((error) => this.onError(error));
  }

  onSuccess(response) {
    // handle success
    hideLoader();
    ConsoleLocalStorage.setOrganization(response.data.data);
    // const api = new DevAuthAPI();
    // api
    //   .assignOwnerRole(this.user.id, {
    //     organization: ConsoleLocalStorage.getOrganization().id,
    //     role: "owner",
    //   })
    //   .then((res) => console.log(res))
    //   .catch((err) => console.log(err));

    this.setState({ step: 1 });
    // console.log(response);
  }
  onError(error) {
    hideLoader();

    // handle error — network/WAF failures have no error.response
    CustomToast(
      error?.response?.data?.message ||
        error?.message ||
        "Something went wrong. Please try again."
    );
  }

  validateNameFormat(name) {
    // const re = /^(([a-z]{1,2})?|[.' ]){3}?([a-z]{3,})+$/i;
    const re = /^([A-Za-z0-9 ]*[A-Za-z]){3,}[A-Za-z0-9 ]*$/i;
    return re.test(String(name));
  }

  validateCityFormat(city) {
    // const re = /^([a-z]+[,.]?[ ]?|[a-z]+['-]?)+$/i;
    const re = /^([A-Za-z ]*[A-Za-z]){3,}[A-Za-z ]*$/;
    return re.test(String(city));
  }

  validateAddressFormat(address) {
    const re = /^[a-zA-Z0-9\s,.'-/]{3,}$/;
    return re.test(String(address));
  }

  handleLogout = () => {
    ConsoleLocalStorage.clearStorageExceptFTU();
    // localStorage.clear();
  };

  render() {
    return (
      <>
        <Navbar showSignup={false} clickDisabled={true} />
        <div>
          <h1
            style={{
              color: "#4096f0",
              fontSize: "20px",
              fontWeight: "bolder",
              textAlign: "center",
              marginTop: "20px",
              fontFamily: "JioType-Black",
            }}
          >
            Welcome {this.user.firstName}
          </h1>
          <h1
            style={{
              color: "#fff",
              fontSize: "12px",
              fontWeight: "bolder",
              textAlign: "center",
              fontFamily: "JioType-Medium",
            }}
          >
            {this.state.step < 2 ? "Tell us about yourself" : "In process..."}
          </h1>
        </div>

        <div className="mx-auto containercreate">
          <div
            className={
              this.state.step === 0
                ? "progress-container mx-auto"
                : this.state.step === 1
                ? "progress-container mx-auto fill-50"
                : "progress-container mx-auto fill-100"
            }
          >
            <div className="progress" id="progress"></div>
            <div className="circle active"></div>
            <div
              className={this.state.step > 1 ? "circle active" : "circle"}
            ></div>
            <div
              className={this.state.step > 2 ? "circle active" : "circle"}
            ></div>
          </div>
          <div className="text-center row progress-text ">
            <div
              className="cursor-pointer col active-text"
              onClick={(e) => {
                if (this.state.step === 1) this.setState({ step: 0 });
              }}
            >
              Organization Information
            </div>
            <div className={this.state.step >= 1 ? "col active-text" : "col"}>
              User Service Agreement
            </div>
            <div className={this.state.step >= 2 ? "col active-text" : "col"}>
              Account Activation
            </div>
          </div>
        </div>

        <div className="mx-auto createformin">
          {this.state.step === 0 ? (
            <div>
              <div>
                <h1
                  style={{
                    color: "#fff",
                    fontSize: "16px",
                    fontFamily: "JioType-Medium",
                  }}
                >
                  Organization Information
                </h1>
              </div>

              <Card
                style={{
                  backgroundColor: "#101010",
                  padding: "0 1rem",
                  borderRadius: "8px",
                  margin: "0 -10px",
                  marginTop: "20px",
                }}
              >
                <h1
                  style={{
                    color: "#fff",
                    fontSize: "12px",
                    textAlign: "left",
                    marginTop: "25px",
                    fontFamily: "JioType-Medium",
                  }}
                >
                  Are you an Individual or Company/Organization?
                </h1>

                <Row style={{ marginTop: "10px" }}>
                  <Col xs={12} md={12}>
                    <div className="m-0 row justify-content-around">
                      <div
                        onClick={(e) => {
                          this.setState({ type: 0 });
                        }}
                        className={
                          this.state.type === 0
                            ? "col-5 text-center my-auto select-div active-border"
                            : "col-5 text-center my-auto select-div"
                        }
                      >
                        <h3 className="">Individual</h3>
                      </div>
                      <div
                        onClick={(e) => {
                          this.setState({ type: 1 });
                        }}
                        className={
                          this.state.type === 1
                            ? "col-5 text-center my-auto select-div active-border"
                            : "col-5 text-center my-auto select-div"
                        }
                      >
                        <h3 className="">Company/Organization</h3>
                      </div>
                    </div>

                    <div>
                      <Col xs={18} md={16} style={{ marginTop: "5px" }}>
                        <Input
                          required="true"
                          label={
                            this.state.type === 0
                              ? "Please provide a name for your developer account"
                              : "Please provide the name of your organization"
                          }
                          maxLen={30}
                          type="text"
                          value={this.state.name.value}
                          pattern="/^([a-z]+[,.]?[ ]?|[0-9]|[a-z]+['-]?)+$/i;"
                          warning={this.state.name.warning}
                          onChange={(e) => {
                            let tempState = {
                              ...this.state.name,
                            };
                            tempState.value = e.target.value;
                            this.setState({
                              name: tempState,
                            });
                            if (!e.target.value) {
                              tempState.warning.msg = "";
                              tempState.warning.class = "";
                            }
                            if (
                              e.target.value.length < 3 &&
                              e.target.value.length > 0
                            ) {
                              tempState.warning.msg =
                                "Minimum 3 characters required";
                              tempState.warning.class = "border-red red";
                            } else if (
                              e.target.value &&
                              !this.validateNameFormat(e.target.value)
                            ) {
                              tempState.warning.msg = "Invalid Name";
                              tempState.warning.class = "border-red red";
                            } else {
                              tempState.warning.msg = "";
                              tempState.warning.class = "";
                            }
                          }}
                          name="name"
                          style={{
                            marginBottom: "10px",
                          }}
                        />
                      </Col>
                      <Col xs={18} md={16}>
                        <Input
                          required={this.state.type === 0 ? false : true}
                          label="Company Website"
                          type="text"
                          name="website"
                          maxLen={260}
                          value={this.state.website.value}
                          warning={this.state.website.warning}
                          onChange={(e) => {
                            let tempState = {
                              ...this.state.website,
                            };
                            tempState.value = e.target.value;
                            this.setState({
                              website: tempState,
                            });
                            if (!e.target.value) {
                              tempState.warning.msg = "";
                              tempState.warning.class = "";
                            }
                            if (
                              e.target.value.length < 4 &&
                              e.target.value.length > 0
                            ) {
                              tempState.warning.msg =
                                "Minimum 4 Characters required";
                              tempState.warning.class = "border-red red";
                            } else if (
                              e.target.value &&
                              !this.validateUrl(e.target.value)
                            ) {
                              tempState.warning.msg = "Invalid Website URL";
                              tempState.warning.class = "border-red red";
                            } else {
                              tempState.warning.msg = "";
                              tempState.warning.class = "";
                            }
                          }}
                          style={{
                            marginBottom: "10px",
                          }}
                        />
                      </Col>
                      <Col xs={18} md={16}>
                        <Input
                          required="true"
                          label="What will be your Publisher name?"
                          type="text"
                          name="pub_name"
                          maxLen={30}
                          value={this.state.publisherName.value}
                          warning={this.state.publisherName.warning}
                          onChange={(e) => {
                            let tempState = {
                              ...this.state.publisherName,
                            };
                            tempState.value = e.target.value;
                            this.setState({
                              publisherName: tempState,
                            });
                            if (!e.target.value) {
                              tempState.warning.msg = "";
                              tempState.warning.class = "";
                            }
                            if (
                              e.target.value.length < 3 &&
                              e.target.value.length > 0
                            ) {
                              tempState.warning.msg =
                                "Minimum 3 characters required";
                              tempState.warning.class = "border-red red";
                            } else if (
                              e.target.value &&
                              !this.validateNameFormat(e.target.value)
                            ) {
                              tempState.warning.msg = "Invalid Publisher Name";
                              tempState.warning.class = "border-red red";
                            } else {
                              tempState.warning.msg = "";
                              tempState.warning.class = "";
                            }
                          }}
                          style={{
                            marginBottom: "10px",
                          }}
                        />
                      </Col>
                      <Row>
                        <Col xs={12} md={6}>
                          <Input
                            required="true"
                            label="Address Line 1"
                            type="text"
                            name="address1"
                            maxLen="200"
                            value={this.state.address1.value}
                            warning={this.state.address1.warning}
                            onChange={(e) => {
                              let tempState = {
                                ...this.state.address1,
                              };
                              tempState.value = e.target.value;
                              this.setState({
                                address1: tempState,
                              });

                              if (!e.target.value) {
                                tempState.warning.msg = "";
                                tempState.warning.class = "";
                              }
                              if (
                                e.target.value.length < 3 &&
                                e.target.value.length > 0
                              ) {
                                tempState.warning.msg =
                                  "Minimum 3 characters required";
                                tempState.warning.class = "border-red red";
                              } else if (
                                e.target.value &&
                                !this.validateAddressFormat(
                                  e.target.value.trim()
                                )
                              ) {
                                tempState.warning.msg = "Invalid Address";
                                tempState.warning.class = "border-red red";
                              } else {
                                tempState.warning.msg = "";
                                tempState.warning.class = "";
                              }
                            }}
                            style={{
                              marginBottom: "10px",
                            }}
                          />
                        </Col>

                        <Col xs={12} md={6}>
                          <Input
                            required="true"
                            label="Address Line 2 "
                            type="text"
                            name="address2"
                            maxLen="200"
                            value={this.state.address2.value}
                            warning={this.state.address2.warning}
                            onChange={(e) => {
                              let tempState = {
                                ...this.state.address2,
                              };
                              tempState.value = e.target.value;
                              this.setState({
                                address2: tempState,
                              });
                              if (!e.target.value) {
                                tempState.warning.msg = "";
                                tempState.warning.class = "";
                              }
                              if (
                                e.target.value.length < 3 &&
                                e.target.value.length > 0
                              ) {
                                tempState.warning.msg =
                                  "Minimum 3 characters required";
                                tempState.warning.class = "border-red red";
                              } else if (
                                e.target.value &&
                                !this.validateAddressFormat(
                                  e.target.value.trim()
                                )
                              ) {
                                tempState.warning.msg = "Invalid Address";
                                tempState.warning.class = "border-red red";
                              } else {
                                tempState.warning.msg = "";
                                tempState.warning.class = "";
                              }
                            }}
                          />
                        </Col>
                      </Row>
                      <Col xs={18} md={16} style={{ marginBottom: "10px" }}>
                        <label className="xs-lable-select white select-arrow">
                          Country <span className="required-span">*</span>
                        </label>
                        <select
                          className="select-area white"
                          value={this.state.country}
                          onChange={(e) => {
                            this.setState({
                              country: e.target.value,
                            });
                          }}
                        >
                          <option value="IN">India</option>
                          <option value="OTH">Other</option>
                        </select>
                      </Col>

                      <Col xs={18} md={16} style={{ marginBottom: "10px" }}>
                        <label className="xs-lable-select white select-arrow">
                          State <span className="required-span">*</span>
                        </label>
                        <select
                          className="select-area white"
                          value={
                            this.state.country === "OTH"
                              ? "Other"
                              : this.state.state
                          }
                          disabled={this.state.country === "OTH" ? true : false}
                          onChange={(e) => {
                            this.setState({
                              state: e.target.value,
                            });
                          }}
                        >
                          <option value="Andhra Pradesh">Andhra Pradesh</option>
                          <option value="Andaman and Nicobar Islands">
                            Andaman and Nicobar Islands
                          </option>
                          <option value="Arunachal Pradesh">
                            Arunachal Pradesh
                          </option>
                          <option value="Assam">Assam</option>
                          <option value="Bihar">Bihar</option>
                          <option value="Chandigarh">Chandigarh</option>
                          <option value="Chhattisgarh">Chhattisgarh</option>
                          <option value="Dadar and Nagar Haveli">
                            Dadar and Nagar Haveli
                          </option>
                          <option value="Daman and Diu">Daman and Diu</option>
                          <option value="Delhi">Delhi</option>
                          <option value="Lakshadweep">Lakshadweep</option>
                          <option value="Puducherry">Puducherry</option>
                          <option value="Goa">Goa</option>
                          <option value="Gujarat">Gujarat</option>
                          <option value="Haryana">Haryana</option>
                          <option value="Himachal Pradesh">
                            Himachal Pradesh
                          </option>
                          <option value="Jammu and Kashmir">
                            Jammu and Kashmir
                          </option>
                          <option value="Jharkhand">Jharkhand</option>
                          <option value="Karnataka">Karnataka</option>
                          <option value="Kerala">Kerala</option>
                          <option value="Madhya Pradesh">Madhya Pradesh</option>
                          <option value="Maharashtra">Maharashtra</option>
                          <option value="Manipur">Manipur</option>
                          <option value="Meghalaya">Meghalaya</option>
                          <option value="Mizoram">Mizoram</option>
                          <option value="Nagaland">Nagaland</option>
                          <option value="Odisha">Odisha</option>
                          <option value="Punjab">Punjab</option>
                          <option value="Rajasthan">Rajasthan</option>
                          <option value="Sikkim">Sikkim</option>
                          <option value="Tamil Nadu">Tamil Nadu</option>
                          <option value="Telangana">Telangana</option>
                          <option value="Tripura">Tripura</option>
                          <option value="Uttar Pradesh">Uttar Pradesh</option>
                          <option value="Uttarakhand">Uttarakhand</option>
                          <option value="West Bengal">West Bengal</option>
                          <option value="Other">Other</option>
                        </select>
                      </Col>

                      <Col xs={18} md={16} style={{ marginBottom: "10px" }}>
                        <Input
                          required="true"
                          label="City"
                          type="text"
                          name="city"
                          maxLen="30"
                          value={this.state.city.value}
                          warning={this.state.city.warning}
                          onChange={(e) => {
                            let tempState = {
                              ...this.state.city,
                            };
                            tempState.value = e.target.value;
                            this.setState({
                              city: tempState,
                            });
                            if (!e.target.value) {
                              tempState.warning.msg = "";
                              tempState.warning.class = "";
                            }
                            if (
                              e.target.value.length < 3 &&
                              e.target.value.length > 0
                            ) {
                              tempState.warning.msg =
                                "Minimum 3 characters required";
                              tempState.warning.class = "border-red red";
                            } else if (
                              e.target.value &&
                              !this.validateCityFormat(e.target.value)
                            ) {
                              tempState.warning.msg = "Invalid Name Format";
                              tempState.warning.class = "border-red red";
                            } else {
                              tempState.warning.msg = "";
                              tempState.warning.class = "";
                            }
                          }}
                          style={{
                            marginBottom: "10px",
                          }}
                        />
                      </Col>
                    </div>
                  </Col>
                </Row>
              </Card>
              <div className="mt-3 text-end">
                <div className="mb-0 next">
                  {ConsoleLocalStorage.getOrganization()?.id ? (
                    <span onClick={(e) => this.validateStepOneForm()}>
                      {"Update"}
                      <img
                        alt=""
                        src={ForwardArrow}
                        height="12"
                        width="13"
                        style={{ marginTop: -2 }}
                      />
                    </span>
                  ) : (
                    <span onClick={(e) => this.validateStepOneForm()}>
                      {"Save & Proceed"}
                      <img
                        alt=""
                        src={ForwardArrow}
                        height="12"
                        width="13"
                        style={{ marginTop: -2 }}
                      />
                    </span>
                  )}
                </div>
              </div>
            </div>
          ) : this.state.step === 1 ? (
            <div>
              {/* kyc page */}
              <div>
                <h1
                  style={{
                    color: "#fff",
                    fontSize: "18px",
                    fontFamily: "JioType-Medium",
                    marginBottom: "20px",
                  }}
                >
                  User Service Agreement
                </h1>

                {this.state.type === 1 ? (
                  <React.Fragment>
                    <p className="step-text">
                      Step 1: Upload your ID Card (Accepted PDF/JPG/PNG){" "}
                      <span className="red">*</span>
                    </p>
                    <p className="step-sub-text">
                      Supported ID types: Company TIN Document / Pan Card
                    </p>

                    <FilePicker
                      text="+ Upload ID here"
                      onComplete={(data) =>
                        this.setState({
                          kycAgreement: data,
                        })
                      }
                      fileTypeCheck={
                        "application/pdf,.pdf,image/jpg,.jpg,image/png,.png,image/jpeg,.jpeg,"
                      }
                    />
                    {/* <div className="file-upload-container">
                      + Upload ID here
                    </div> */}
                    <div className="step-2">
                      <p className="mt-4 step-text theme__font--medium ">
                        Step 2: Download the format of Authorization Letter
                        <span className="red">*</span>
                      </p>
                      <div>
                        <button
                          className="btn-tess dark width-full theme__font--medium font-size-12"
                          onClick={async () => {
                            try {
                              await downloadAuthenticatedDocument(
                                "StandardAuthorizationLetter.docx",
                                "dc-documents"
                              );
                            } catch (error) {
                              console.error("Download failed:", error);
                              // Fallback to direct CDN URL if proxy fails
                              window.open(
                                "https://tess-blob-cdn.azureedge.net/dc-documents/StandardAuthorizationLetter.docx"
                              );
                            }
                          }}
                        >
                          <img
                            src={downloadIcon}
                            alt="Download button"
                            className="mr-15 ws-15"
                          />
                          Sample Authorization Letter
                        </button>
                      </div>
                    </div>

                    <p className="mt-4 step-text">
                      Step 3: Upload your Authorization Letter (Accepted
                      PDF/JPG/PNG/DOC) <span className="red">*</span>
                    </p>

                    <FilePicker
                      text=" + Upload Authorization Letter here"
                      fileTypeCheck={
                        "application/pdf,.pdf, image/jpg,.jpg,image/png,.png, image/jpeg, .jpeg,.docx,.doc,"
                      }
                      onComplete={(data) =>
                        this.setState({
                          authLetter: data,
                        })
                      }
                    />
                    {/* <div className="file-upload-container">
                      + Upload Authorization Letter here
                    </div> */}

                    <p className="mt-4 step-text">
                      Step 4: Non-Disclosure Agreement (NDA){" "}
                      <span className="red">*</span>
                    </p>

                    <Card className="agreement-card-div ">{AgreementText}</Card>
                  </React.Fragment>
                ) : (
                  this.state.type === 0 && (
                    <React.Fragment>
                      <p className="step-text">
                        Step 1: Upload your ID Card (Accepted PDF/JPG/PNG)
                        <span className="red">*</span>
                      </p>
                      <p className="step-sub-text">
                        Supported ID types: PAN Card / Driving License
                      </p>
                      <FilePicker
                        text="+ Upload ID here"
                        fileTypeCheck={".pdf,.jpg,.png,.jpeg,"}
                        onComplete={(data) => {
                          this.setState({
                            kycAgreement: data,
                          });
                        }}
                      />
                      <p className="mt-4 step-text">
                        Step 2: Non-Disclosure Agreement (NDA){" "}
                        <span className="red">*</span>
                      </p>

                      <Card className="agreement-card-div ">
                        {AgreementText}
                      </Card>
                    </React.Fragment>
                  )
                )}

                <div className="mt-4">
                  <Checkbox
                    label="I agree to the terms and conditions."
                    id="agreement"
                    onChange={(e) =>
                      this.setState({
                        iAgree: e.target.checked,
                      })
                    }
                  />
                </div>
                <div
                  onClick={(e) => this.submitStepTwoForm()}
                  className="text-end"
                >
                  <PrimaryButton>Submit</PrimaryButton>
                </div>
              </div>
            </div>
          ) : !this.state.orgRejected ? (
            <div>
              <div>
                <Container className="text-center col-xs-1">
                  <img alt="" src={MailSent} height="25" />
                  <h4 className="mt-2 header">Sent for activation</h4>
                  <p className="mt-4 mail-content">
                    Usually it takes 2 to 3 working days. Will notify you by
                    mail once it is activated.{" "}
                  </p>

                  <Link
                    onClick={() => {
                      this.handleLogout();
                    }}
                    to="/"
                  >
                    <div className="link">
                      Sign out{" "}
                      <img
                        alt=""
                        src={ForwardArrow}
                        height="12"
                        width="13"
                        style={{ marginTop: -2 }}
                      />
                    </div>
                  </Link>
                </Container>
              </div>
            </div>
          ) : (
            this.state.orgRejected && (
              <div className="text-white">
                <div className="d-flex d-flex-column d-align-center">
                  <img alt="Expired" src={Exclamation} />
                  <h4 className="mt-15 mbc-5">
                    Your account activation request was rejected
                  </h4>
                  <p className="mt-4">
                    Your account could not be activated due to the following
                    reasons :
                  </p>
                </div>
                <TextArea value={this.state.rejectionText} readOnly={true} />
                <div className="d-flex d-justify-center d-align-center pt-10">
                  <span
                    onClick={() => this.updateData()}
                    className="link d-flex d-justify-center c-pointer "
                  >
                    Edit Info
                  </span>
                  <img
                    alt="ForwardArrow"
                    src={ForwardArrow}
                    className="mlc-10"
                  />
                </div>
              </div>
            )
          )}
        </div>
      </>
    );
  }
}

export default CreateOrganization;
